import { Item, ObjectGeneric } from "../../../../../../../utils/types/generals";

const rowFilter = ({ rows, data }: { rows: any[]; data: ObjectGeneric }) => {
    return rows.filter(row => (
        (!data?.users?.length || data?.users.some((user: Item) => user.value == row.userId)) &&
        (!data?.store?.length || data?.store.some((store: Item) => store.value == row.storeId)) &&
        (!data?.questionnaires?.length || data?.questionnaires.some((questionnaire: Item) => questionnaire.value == row.questionnaireId))
    ))
}

export { rowFilter }